import React from "react";
import styled from "styled-components";

const RoyalRankTable = styled.div`
  table {
    min-width: fit-content;
    width: 100%;
  }

  tr:nth-child(even) {
    background-color: #f1f1f1;
  }
  th {
    background-color: #eaeaea;
  }

  th,
  td {
    text-align: center;
    padding: 10px;
  }

  @media (min-width: 780px) {
    max-height: 70vh;
  }

  .tooltip {
    position: relative;
    cursor: pointer;
  }

  .tooltip:hover .tooltip-text {
    visibility: visible;
    opacity: 1;
  }

  .tooltip-text {
    visibility: hidden;
    opacity: 0;
    position: absolute;
    background-color: black;
    color: white;
    text-align: center;
    padding: 5px;
    border-radius: 4px;
    top: -30px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
    transition: opacity 0.2s ease-in-out;
  }
`;

const getClassification = (points) => {
  if (points <= 4) return "Exiled";
  if (points <= 25) return "Warrior";
  if (points <= 51) return "Knight";
  if (points <= 77) return "Master";
  if (points <= 120) return "Master of War";
  return "GrandMaster";
};

const classSubClassMap = {
  0: "TK",
  1: "FM",
  2: "BM",
  3: "HT",
};

const headerMap = {
  charName: "Nick Player",
  class: "Class/SubClass",
  kills: "Kills",
  deaths: "Deaths",
  wins: "Wins",
  points: "CS",
  bonusKill: "Bonus Kill",
  total: "Total",
};

const Table = ({ data }) => {
  if (!Array.isArray(data) || data.length === 0)
    return <p>Aguardando resultado da arena...</p>;

  const enriched = data.map((row) => {
    const pts = row.points ?? 0;
    //    const regs = row.registerCount ?? 0;
    const kills = row.kills ?? 0;

    // Novo cálculo de bonusKill
    const bonusKill = Math.floor(kills / 10);

    // Ajuste de pontos
    let adjustedPoints = pts; // - regs;
    adjustedPoints = Math.max(0, Math.min(250, adjustedPoints));

    // Soma o bonusKill ao total
    const total = adjustedPoints + bonusKill;

    return {
      ...row,
      adjustedPoints,
      bonusKill,
      total,
    };
  });

  const sorted = enriched.sort((a, b) => b.total - a.total);
  const keys = [
    "charName",
    "class",
    "kills",
    "deaths",
    "wins",
    "points",
    "bonusKill",
    "total",
  ];

  return (
    <RoyalRankTable>
      <table>
        <thead>
          <tr>
            <th>Position</th>
            {keys.map((key) => {
              if (key === "charName") {
                return (
                  <React.Fragment key={key}>
                    <th>{headerMap[key]}</th>
                    <th>Classification</th>
                  </React.Fragment>
                );
              }
              return <th key={key}>{headerMap[key] || key}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {sorted
            .filter((row) => row.points !== -1 && row.total !== -1)
            .map((row, index) => {
              // conta duplicados de nickname para tooltip
              const isDuplicate =
                sorted.filter((r) => r.charName === row.charName).length > 1;
              return (
                <tr key={`${row.charName}-${index}`}>
                  <td>{index + 1}º</td>
                  {keys.map((key) => {
                    switch (key) {
                      case "charName": {
                        return (
                          <React.Fragment key={key}>
                            <td>
                              <div className="tooltip">
                                {row.charName}
                                {isDuplicate && (
                                  <span className="tooltip-text">
                                    Jogador possui mais de um personagem com
                                    esse nome
                                  </span>
                                )}
                              </div>
                            </td>
                            <td>{getClassification(row.adjustedPoints)}</td>
                          </React.Fragment>
                        );
                      }
                      case "class": {
                        const cls = classSubClassMap[row.class] ?? row.class;
                        const sub =
                          classSubClassMap[row.subClass] ?? row.subClass;
                        let subValue = sub === 250 ? "" : `/${sub}`;
                        return <td key={key}>{`${cls}${subValue}`}</td>;
                      }
                      case "points": {
                        return <td key={key}>{row.adjustedPoints}</td>;
                      }
                      case "total": {
                        return <td key={key}>{row.total}</td>;
                      }
                      default:
                        return <td key={key}>{row[key]}</td>;
                    }
                  })}
                </tr>
              );
            })}
        </tbody>
      </table>
    </RoyalRankTable>
  );
};

export default Table;
